import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const SERVICES = [
  { label: 'Past Prediction' },
  { label: 'Future Consultation' },
  { label: 'Tarot Reading' },
  { label: 'Palmistry Reading' },
  { label: 'Numerology Reading' },
  { label: 'Online Vastu' },
  { label: 'Remedies by Tilak' },
];

const COMPANY = [
  { label: 'About Tilak',   href: '/about' },
  { label: 'Our Services',  href: '/services' },
  { label: 'Contact Us',    href: '/contact' },
];

const LEGAL = [
  { label: 'Privacy Policy',   href: '/privacy' },
  { label: 'Terms of Service', href: '/terms' },
  { label: 'Refund Policy',    href: '/terms#refund' },
];

const Footer = () => (
  <footer className="footer" role="contentinfo">
    <div className="footer__inner">

      {/* Brand */}
      <div className="footer__brand">
        <div className="footer__logo">
          <FooterSun />
          <div className="footer__logo-text-wrap">
            <span className="footer__logo-text">VTD</span>
            <span className="footer__logo-sub">Astrology</span>
          </div>
        </div>
        <p className="footer__tagline">Vision Towards Destiny</p>
        <p className="footer__desc">
          Premium Vedic Astrology by VTD certified experts.
          Authentic readings in Telugu, Hindi and English.
          Every session fixed price — no surprises.
        </p>
        <div className="footer__social">
          <a href="https://www.instagram.com/vtd.astrology?igsh=NHZxd3p1MmRoMncz"
            className="social-icon social-icon--ig" aria-label="Instagram" target="_blank" rel="noopener noreferrer"><IGIcon /></a>
          <a href="https://www.facebook.com/share/1EH2UqAzWm/"
            className="social-icon social-icon--fb" aria-label="Facebook"  target="_blank" rel="noopener noreferrer"><FBIcon /></a>
          <a href="/chat"
            className="social-icon social-icon--wa" aria-label="Chat"><WAIcon /></a>
        </div>
      </div>

      {/* Services */}
      <div className="footer__col">
        <h4 className="footer__col-title">Services</h4>
        <ul className="footer__links">
          {SERVICES.map(s => (
            <li key={s.label}>
              <a href="/chat" className="footer__link">{s.label}</a>
            </li>
          ))}
        </ul>
      </div>

      {/* Company */}
      <div className="footer__col">
        <h4 className="footer__col-title">Company</h4>
        <ul className="footer__links">
          {COMPANY.map(c => (
            <li key={c.label}>
              <Link to={c.href} className="footer__link">{c.label}</Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Legal */}
      <div className="footer__col">
        <h4 className="footer__col-title">Legal</h4>
        <ul className="footer__links">
          {LEGAL.map(l => (
            <li key={l.label}>
              <Link to={l.href} className="footer__link">{l.label}</Link>
            </li>
          ))}
        </ul>
        <div className="footer__contact-block">
          <p className="footer__contact-label">Business Hours</p>
          <p className="footer__contact-val">Mon–Sat · 9AM–8PM IST</p>
          <a href="/chat" className="footer__wa-btn">
            💬 Chat with Tilak
          </a>
        </div>
      </div>
    </div>

    <div className="footer__bottom">
      <div className="gold-divider" style={{ margin: '0 0 1.5rem' }} />
      <p className="footer__disclaimer">
        <strong>Disclaimer:</strong> Vedic astrology is for spiritual guidance and entertainment purposes only.
        VTD Astrology does not guarantee specific outcomes and does not replace professional medical,
        legal or financial advice.
      </p>
      <p className="footer__copyright">
        © {new Date().getFullYear()} VTD Astrology — vtdastrology.com · All rights reserved.
      </p>
    </div>
  </footer>
);

const FooterSun = () => (
  <svg viewBox="0 0 40 40" width="34" height="34" aria-hidden="true">
    <circle cx="20" cy="20" r="9" fill="#D4AF37" />
    <circle cx="20" cy="20" r="5" fill="#FFD700" />
    {[0,45,90,135,180,225,270,315].map((deg,i)=>{
      const r=(deg*Math.PI)/180;
      return <line key={i} x1={20+Math.cos(r)*12} y1={20+Math.sin(r)*12}
        x2={20+Math.cos(r)*17} y2={20+Math.sin(r)*17} stroke="#FFD700" strokeWidth="1.8" strokeLinecap="round"/>;
    })}
  </svg>
);

const IGIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="2" y="2" width="20" height="20" rx="5"/>
    <circle cx="12" cy="12" r="4"/>
    <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none"/>
  </svg>
);
const FBIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);
const WAIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

export default Footer;
